import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { registerSW } from "./registerSW";
import { initSentry } from "./sentry";

// US237: initialise Sentry before rendering so errors during
// initialisation and the first render are captured.
initSentry();

registerSW();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
